{
  "el": {
    "issue": {
      "actions": {
        "approve_for_customer": "Έγκριση για τον πελάτη",
        "assign": "Ανάθεση",
        "collapse": "Σύμπτυξη παρατηρήσεων",
        "create_category": "Προσθήκη νέας κατηγορίας",
        "create_issue": "Δημιουργία παρατήρησης",
        "create_issue_customer": "Αναφορά παρατήρησης",
        "delete": "Διαγραφή παρατήρησης",
        "expand": "Ανάπτυξη παρατηρήσεων",
        "export_images": "Λήψη εικόνων",
        "hideActivity": "Απόκρυψη ιστορικού",
        "openConversation": "Άνοιγμα συνομιλίας",
        "reject_for_customer": "Απόρριψη για τον πελάτη",
        "show": "Εμφάνιση παρατήρησης",
        "showActivity": "Εμφάνιση ιστορικού",
        "startConversation": "Έναρξη συνομιλίας",
        "start_conversation": "Έναρξη συνομιλίας για αυτή την παρατήρηση",
        "undo_customer_approval": "Αναίρεση έγκρισης πελάτη",
        "undo_customer_rejection": "Αναίρεση απόρριψης πελάτη",
        "update": "Ενημέρωση παρατηρήσεων"
      },
      "attributes": {
        "approval_status": "Έγκριση πελάτη",
        "assignee": "Υπεύθυνος",
        "category": "Κατηγορία",
        "created_at": "Δημιουργήθηκε",
        "deadline": "Προθεσμία",
        "description": "Περιγραφή",
        "internal_note": "Εσωτερική σημείωση",
        "issue_list_type": "Λίστα παρατηρήσεων",
        "name": "Όνομα",
        "responsible": "Υπεύθυνος",
        "status": "Κατάσταση",
        "statuses": {
          "approval_not_requested": "Δεν ζητήθηκε",
          "approval_requested": "Ζητήθηκε",
          "approved": "Εγκρίθηκε",
          "completed": "Ολοκληρωμένη",
          "created": "Ανοιχτή",
          "declined": "Απορρίφθηκε",
          "inbox": "Στάλθηκε",
          "not_completed": "Μη ολοκληρωμένη",
          "ongoing": "Σε εξέλιξη"
        },
        "updated_at": "Τελευταία ενημέρωση"
      },
      "edit_actions": {
        "edit_category": "Κατηγορία",
        "edit_deadline": "Προθεσμία",
        "edit_issue_list_type": "Λίστα παρατηρήσεων",
        "edit_responsible": "Υπεύθυνος",
        "edit_status": "Κατάσταση"
      },
      "labels": {
        "activity": "Εμφάνιση ιστορικού",
        "addImagesSubtitle": "Μια εικόνα αξίζει όσο χίλιες λέξεις",
        "addImagesTitle": "Πρόσθεσε εικόνες για να καταλάβουμε ακόμα καλύτερα την παρατήρηση",
        "after_care_page_title": "Οι παρατηρήσεις σου",
        "all_categories_can_be_managed_under": "Όλες οι κατηγορίες διαχειρίζονται στις",
        "approvalNotRequested": "Δεν ζητήθηκε έγκριση",
        "approvalRequested": "Ζητήθηκε έγκριση",
        "approved": "Εγκρίθηκε",
        "approvedInfo": "Ο πελάτης ενέκρινε αυτή την παρατήρηση",
        "assignee": "Υπεύθυνος",
        "cancelCustomerApproval": "Ακύρωση αιτήματος έγκρισης πελάτη",
        "collapse": "Απόκρυψη ιστορικού",
        "company_settings": "ρυθμίσεις του οργανισμού",
        "count_edit": "Επεξεργασία παρατήρησης | Επεξεργασία {count} παρατηρήσεων",
        "create_new_category?": "Δεν βρίσκεις την κατηγορία που χρειάζεσαι; Δημιούργησε μια νέα.",
        "created_at": "Δημιουργήθηκε στις",
        "customerApproved": "Εγκρίθηκε από τον πελάτη",
        "customerRejected": "Απορρίφθηκε από τον πελάτη",
        "deadline_date": "Προθεσμία",
        "description": "Περιγραφή",
        "descriptionSubtitle": "Χρησιμοποίησε κουκκίδες και σύντομες προτάσεις για να καταλάβουμε πιο εύκολα την παρατήρηση",
        "descriptionTitle": "Δώσε μια σύντομη περιγραφή",
        "edit_category": "Επεξεργασία κατηγορίας",
        "edit_issue": "Επεξεργασία παρατήρησης",
        "internal_note_hint": "Μόνο η ομάδα σου το βλέπει. Οι πελάτες και οι συνεργάτες ποτέ.",
        "isThisPointFixed": "Θεωρείς ότι έχει διορθωθεί;",
        "issue_category_name": "Κατηγορία",
        "issue_status_name": "Κατάσταση",
        "issues_clear_selection": "Εκκαθάριση επιλογής",
        "issues_select_all_pages": "Επιλογή και των {total} παρατηρήσεων",
        "issues_select_one": "Επίλεξε τουλάχιστον 1 παρατήρηση",
        "issues_selected": "επιλεγμένες παρατηρήσεις",
        "issues_selected_all_pages": "Επιλέχθηκαν και οι {total} παρατηρήσεις",
        "issues_selected_count": "{selected} επιλεγμένη παρατήρηση | {selected} επιλεγμένες παρατηρήσεις",
        "name": "Όνομα",
        "new": "Δημιουργία νέας παρατήρησης",
        "new_category": "Νέα κατηγορία",
        "noDescriptionYet": "Δεν υπάρχει ακόμη περιγραφή",
        "no_issue_deadline": "Δεν έχει οριστεί προθεσμία",
        "no_issues": "Καμία παρατήρηση",
        "no_responsible": "Χωρίς υπεύθυνο",
        "origin": "Προέλευση",
        "reason": "Αιτιολογία",
        "redoRequest": "Επανάληψη αιτήματος",
        "requestCustomerApproval": "Αίτημα έγκρισης πελάτη",
        "requested": "Ζητήθηκε",
        "requestedInfo": "Ζητήθηκε έγκριση από τον πελάτη",
        "resetRequest": "Επαναφορά αιτήματος",
        "responsible_of_Employee_type_last_name_or_responsible_of_Partner_type_last_name": "Υπεύθυνος",
        "return_to_overview": "Επιστροφή",
        "showIssuesfor": "Εμφάνιση παρατηρήσεων για",
        "statusExplained": "Τι σημαίνει κάθε χρώμα κατάστασης",
        "subjectSubtitle": "Χρειάζεται μόνο 1 αναφορά ανά παρατήρηση. Τα υπόλοιπα τα αναλαμβάνουμε εμείς",
        "subjectTitle": "Περίγραψε την παρατήρηση με λίγα λόγια",
        "unit_issues_will_be_shown_here": "Εδώ θα εμφανίζονται όλα τα ακίνητα που είναι συνδεδεμένα με τη λίστα παρατηρήσεων",
        "unit_name": "Όνομα ακινήτου",
        "updated_at": "Τελευταία ενημέρωση",
        "waitingForApproval": "Αυτή η παρατήρηση πρέπει πρώτα να γίνει αποδεκτή από {client_name} για να μπορέσεις να ξεκινήσεις συνομιλία",
        "whyIsThisPointNotFixed": "Γιατί δεν έχει διορθωθεί αυτή η παρατήρηση;",
        "youApprovedThisPoint": "Διορθώθηκε κατά τη γνώμη σου",
        "youRejectedThisPoint": "Δεν διορθώθηκε κατά τη γνώμη σου"
      },
      "placeholders": {
        "customers": {
          "none": {
            "subtitle": "Θα ειδοποιηθείς αν αναφερθεί νέα παρατήρηση.",
            "title": "Δεν έχει αναφερθεί ακόμη καμία παρατήρηση για το ακίνητό σου"
          }
        },
        "employees": {
          "inbox": {
            "subtitle": "Όταν οι πελάτες δημιουργούν νέες παρατηρήσεις, θα εμφανίζονται ξανά εδώ.",
            "title": "Έχεις επεξεργαστεί όλες τις εισερχόμενες παρατηρήσεις από πελάτες"
          },
          "none": {
            "subtitle": "Ξεκίνα να καταγράφεις τι πρέπει να διορθωθεί ή να βελτιωθεί",
            "title": "Δημιούργησε την πρώτη σου παρατήρηση"
          },
          "overview": {
            "subtitle": "Δημιούργησε την πρώτη σου παρατήρηση μέσα σε ένα ακίνητο για να ξεκινήσεις",
            "title": "Εδώ θα εμφανίζονται οι παρατηρήσεις από όλα τα ακίνητά σου"
          },
          "unit": {
            "title": "Εδώ θα εμφανίζονται όλες οι παρατηρήσεις για αυτό το ακίνητο"
          }
        },
        "partners": {
          "none": {
            "subtitle": "Από τη στιγμή που θα σου ανατεθούν παρατηρήσεις, θα εμφανίζονται εδώ",
            "title": "Δεν σου έχει ανατεθεί ακόμη καμία παρατήρηση"
          }
        }
      },
      "sortGroups": {
        "date": "Ημερομηνία",
        "deadline": "Προθεσμία",
        "name": "Όνομα"
      },
      "toasts": {
        "update": "Η παρατήρηση ενημερώθηκε"
      },
      "validation": {
        "issue_list_type_required": "Η λίστα παρατηρήσεων είναι υποχρεωτική",
        "pleaseProvideAReason": "Δώσε μια αιτιολογία",
        "status_required": "Η κατάσταση είναι υποχρεωτική"
      }
    }
  }
}
